import {subdebug} from '@sanity/cli-core'

export const deployDebug = subdebug('deploy')
